import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AuthModal from "@/components/feature/AuthModal";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import { useTheme } from "@/contexts/ThemeContext";

export default function Home() {
  const { isDark } = useTheme();
  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? "bg-[#0a0a0f]" : "bg-white"}`}>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
      </main>
      <Footer />
      <AuthModal />
    </div>
  );
}
